<template>
  <div class="income-workbench">
    <section class="toolbar-panel glass-panel">
      <div class="income-filter-row">
        <label class="hf-form-item filter-id">
          <span class="hf-label">小程序</span>
          <input class="hf-field" v-model="queryParams.videoNoUserId" placeholder="请输入小程序名">
        </label>
        <label class="hf-form-item filter-id">
          <span class="hf-label">视频号ID</span>
          <input class="hf-field" v-model="queryParams.mediaId" placeholder="请输入视频号ID">
        </label>
        <label class="hf-form-item filter-id">
          <span class="hf-label">素材ID</span>
          <input class="hf-field" v-model="queryParams.videoId" placeholder="请输入素材ID">
        </label>
        <label class="hf-form-item filter-date">
          <span class="hf-label">开始日期</span>
          <input class="hf-field" v-model="queryParams.startTime" type="date">
        </label>
        <label class="hf-form-item filter-date">
          <span class="hf-label">结束日期</span>
          <input class="hf-field" v-model="queryParams.endTime" type="date">
        </label>
        <div class="form-actions">
          <button class="hf-btn hf-btn--primary" type="button" @click="handleQuery">搜索</button>
          <button class="hf-btn" type="button" @click="resetQuery">重置</button>
          <button class="hf-btn hf-btn--primary" type="button" :disabled="isStating" @click="handleStatic">
            {{ isStating ? '统计中' : '统计' }}
          </button>
        </div>
      </div>
    </section>

    <section class="table-panel glass-panel">
      <div class="action-row">
        <button class="hf-btn" type="button" :disabled="fullscreenLoading" @click="handleExport">
          {{ fullscreenLoading ? '导出中' : '导出' }}
        </button>
        <button class="hf-btn hf-btn--primary" type="button" :disabled="fullscreenLoading" @click="handleSynchronize">采集</button>
      </div>
      <div class="hf-table-wrap">
        <table class="hf-table mini-income-table">
          <colgroup>
            <col class="col-name">
            <col class="col-date">
            <col class="col-id">
            <col class="col-id-wide">
            <col class="col-money">
          </colgroup>
          <thead>
            <tr>
              <th>小程序</th>
              <th>统计时间</th>
              <th>视频号ID</th>
              <th>素材ID</th>
              <th>收入(分)</th>
            </tr>
          </thead>
          <tbody v-if="incomeStaticList.length">
            <tr v-for="row in incomeStaticList" :key="row.id || `${row.collectDate}_${row.videoId}`">
              <td :data-tooltip="row.videoNoUserId || null">{{ row.videoNoUserId }}</td>
              <td>{{ row.collectDate }}</td>
              <td :data-tooltip="row.mediaId || null">{{ row.mediaId }}</td>
              <td :data-tooltip="row.videoId || null">{{ row.videoId }}</td>
              <td class="number-cell">{{ row.advertisingRevenue }}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="!incomeStaticList.length && !loading" class="hf-table-empty">暂无小程序统计数据</div>
        <div v-if="loading" class="hf-loading">加载中...</div>
      </div>
      <div class="pagination-wrap">
        <div class="hf-pagination">
          <button class="hf-page-btn" type="button" :disabled="now <= 1" @click="findPage(now - 1)">‹</button>
          <button
            v-for="page in pageNumbers"
            :key="page"
            class="hf-page-btn"
            :class="{ active: page === now }"
            type="button"
            @click="findPage(page)"
          >{{ page }}</button>
          <button class="hf-page-btn" type="button" :disabled="now >= pageCount" @click="findPage(now + 1)">›</button>
          <select class="hf-select page-size" v-model.number="size" @change="findSize(size)">
            <option v-for="item in [10, 30, 50, 100]" :key="item" :value="item">{{ item }} 条/页</option>
          </select>
          <span>共 {{ total }} 条</span>
        </div>
      </div>
    </section>

    <div v-if="statisticDialogVisible" class="hf-modal-mask">
      <section class="hf-modal hf-modal--wide">
        <div class="hf-modal__header">
          <div>
            <p class="modal-kicker">STATISTIC</p>
            <h3 class="hf-modal__title">统计结果</h3>
          </div>
          <button class="hf-modal__close" type="button" @click="statisticDialogVisible = false">×</button>
        </div>
        <div class="stat-grid stat-grid--modal">
          <div class="stat-card">
            <p class="stat-label">视频播放量</p>
            <div class="stat-value">{{ statistic.videoVisitNum || 0 }}</div>
          </div>
          <div class="stat-card">
            <p class="stat-label">剧集播放量</p>
            <div class="stat-value">{{ statistic.videoSerialsNum || 0 }}</div>
          </div>
          <div class="stat-card">
            <p class="stat-label">收益</p>
            <div class="stat-value">{{ statistic.advertisingRevenue || 0 }}</div>
          </div>
        </div>
      </section>
    </div>

    <div v-if="showSynchronizeDialog" class="hf-modal-mask">
      <section class="hf-modal">
        <div class="hf-modal__header">
          <h3 class="hf-modal__title">数据同步</h3>
          <button class="hf-modal__close" type="button" @click="showSynchronizeDialog = false">×</button>
        </div>
        <label class="hf-form-item">
          <span class="hf-label">同步日期</span>
          <input class="hf-field" v-model="synchronizeDate" type="date">
        </label>
        <div class="action-buttons">
          <button
            class="hf-btn hf-btn--primary"
            type="button"
            :disabled="!synchronizeDate"
            @click="confirmSynchronize"
          >
            确定
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import {
  exportNlMiniProgramStatic,
  synchronizeMiniProgramData,
  pageNlPromotionIncomeStatic,
  statisticNlPromotionIncomeStatic,
} from "@/api/IncomeStatic";
import {saveAs} from 'file-saver'

export default {
  props: {
    isMiniProgram: {
      default: 0
    }
  },
  data() {
    return {
      fullscreenLoading: false,
      isStating: false,
      synchronizeDate: '',
      showSynchronizeDialog: false,
      statisticDialogVisible: false,
      total: 0,
      now: 1,
      size: 10,
      loading: false,
      queryParams: {
        isMiniProgram: this.isMiniProgram !== undefined && this.isMiniProgram !== null ? this.isMiniProgram : 0,
      },
      incomeStaticList: [],
      statistic: {},
    };
  },
  computed: {
    programFlag() {
      return this.isMiniProgram !== undefined && this.isMiniProgram !== null
        ? this.isMiniProgram
        : 0;
    },
    pageCount() {
      return Math.max(1, Math.ceil(this.total / this.size));
    },
    pageNumbers() {
      const pages = [];
      const start = Math.max(1, this.now - 2);
      const end = Math.min(this.pageCount, start + 4);
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  mounted() {
    this.getList();
  },
  watch: {
    programFlag(value) {
      this.queryParams.isMiniProgram = value;
    }
  },
  methods: {
    handleSynchronize() {
      this.synchronizeDate = '';
      this.showSynchronizeDialog = true;
    },
    confirmSynchronize() {
      this.$confirmDialog(`确定要删除 ${this.synchronizeDate} 的数据并重新拉取吗?`).then((ok) => {
        if (ok) {
          this.doSynchronize();
        }
      });
    },
    getStatistic() {
      this.isStating = true;
      statisticNlPromotionIncomeStatic(this.queryParams).then(response => {
        this.statistic = response.data || {};
        this.statisticDialogVisible = true;
      }).finally(() => {
        this.isStating = false;
      });
    },
    getList() {
      this.loading = true;
      pageNlPromotionIncomeStatic(this.now, this.size, this.queryParams).then(response => {
        this.incomeStaticList = response.data.records;
        this.total = response.data.total;
      }).finally(() => {
        this.loading = false;
      });
    },
    doSynchronize() {
      this.showSynchronizeDialog = false;
      this.loading = true;
      synchronizeMiniProgramData(this.synchronizeDate).then(res => {
        if (res.code == 500) {
          this.$notify({
            title: '同步失败',
            message: res.message,
            type: 'error'
          })
        }
        this.handleQuery();
      }).finally(() => {
        this.loading = false;
      });
    },
    resetQuery() {
      this.queryParams = {
        isMiniProgram: this.programFlag,
      };
      this.handleQuery();
    },
    handleQuery() {
      this.now = 1;
      this.getList();
    },
    handleStatic() {
      this.getStatistic();
    },
    handleExport() {
      this.fullscreenLoading = true;
      exportNlMiniProgramStatic(this.queryParams).then(async (data) => {
        const blob = new Blob([data])
        saveAs(blob, `小程序IAA挂载统计_${new Date().getTime()}.xlsx`)
      }).catch((r) => {
        console.error(r)
      }).finally(() => {
        this.fullscreenLoading = false;
      })
    },
    findPage(nowPage) {
      this.now = nowPage;
      this.showPageInfo(nowPage, this.size);
    },
    findSize(nowSize) {
      this.size = nowSize;
      this.now = 1;
      this.showPageInfo(this.now, nowSize);
    },
    showPageInfo(currentPage, pageSize) {
      currentPage = currentPage || this.now;
      pageSize = pageSize || this.size;
      this.selectResolveAddress(currentPage, pageSize);
    },
    selectResolveAddress(currentPage, pageSize) {
      this.loading = true;
      pageNlPromotionIncomeStatic(currentPage, pageSize, this.queryParams).then((res) => {
        this.incomeStaticList = res.data.records;
        this.total = res.data.total;
      }).finally(() => {
        this.loading = false;
      });
    },
  }
};
</script>

<style scoped>
.income-workbench {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.income-filter-row {
  display: flex;
  align-items: flex-end;
  flex-wrap: nowrap;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 2px;
}

.filter-id {
  flex: 0 0 146px;
}

.filter-date {
  flex: 0 0 142px;
}

.form-actions {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-end;
  flex-wrap: nowrap;
  gap: 8px;
}

.mini-income-table {
  min-width: 820px;
}

.mini-income-table .col-name {
  width: 180px;
}

.mini-income-table .col-date {
  width: 140px;
}

.mini-income-table .col-id {
  width: 170px;
}

.mini-income-table .col-id-wide {
  width: 220px;
}

.mini-income-table .col-money {
  width: 110px;
}

.mini-income-table .number-cell {
  color: #101828;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  text-align: right;
}

.pagination-wrap {
  display: flex;
  justify-content: flex-start;
  padding-top: 14px;
  overflow-x: auto;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
}

.page-size {
  width: 110px;
}

.modal-kicker {
  margin: 0 0 5px;
  color: #98a2b3;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: .12em;
}

.stat-grid--modal .stat-card {
  box-shadow: none;
}

@media (max-width: 720px) {
  .income-filter-row {
    align-items: stretch;
    flex-direction: column;
    overflow-x: visible;
  }

  .filter-id,
  .filter-date {
    flex: auto;
  }

  .form-actions {
    flex-wrap: wrap;
  }
}
</style>
